import accountApi from '@/api/account'

const state = () => ({
  all: []
})

const getters = {
  all: state => {
    return state.all
  }
}

const actions = {
  async getAccounts ({ commit }, params) {
    const result = await accountApi.getAll(params)
    commit('setAccounts', result.data)
  }
}

const mutations = {
  setAccounts (state, accounts) {
    state.all = accounts
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}